import React from 'react'
import { shallow } from 'enzyme'
import { AppDetails } from '../AppDetails'
import Product from '../features/product/Product'

describe('<AppDetails />', () => {
  let wrapper, props, instance

  beforeEach(() => {
    props = {
      loan: {},
      data: {
        products: [
          {
            name: 'not QD',
            quickDraw: false
          },
          {
            name: 'QD',
            quickDraw: true
          }
        ]
      },
      loanId: 1,
      productName: 'name',
      superUser: true
    }
    wrapper = shallow(<AppDetails {...props} />)
    instance = wrapper.instance()
  })

  describe('#render', () => {
    it('should return an obj', () => {
      expect(wrapper).toBeTruthy()
    })
  })

  describe('#Product render', () => {
    it('should return a <Product />', () => {
      expect(wrapper.find(Product)).toHaveLength(1)
    })
  })

  describe('#filteredProducts', () => {
    describe('when is super user', () => {
      it('should return array', () => {
        const { filteredProducts } = instance

        expect(filteredProducts.length).toBe(2)
      })
    })

    describe('when is not super user', () => {
      it('should return array', () => {
        wrapper.setProps({ superUser: false })
        const { filteredProducts } = instance

        expect(filteredProducts.length).toBe(1)
      })
    })
  })
})
